import { InvestmentsResponse } from "../../../services";
import { InvestmentsHeadlineChange, InvestmentsTotals } from "../types";

// Keyed once and picked off the response, so a new totals field cannot be threaded
// on the loaded branch and silently forgotten on the pre-load one.
const ZERO: InvestmentsTotals = {
  investedValue: 0,
  portfolioValue: 0,
  totalValue: 0,
  earnedValue: 0,
  withdrawnValue: 0,
  brokerCosts: 0,
  accountFeeCosts: 0,
  interestCosts: 0,
  adjustmentsNet: 0,
  totalReturnPercent: null,
  totalReturnPercentStateReason: null,
};

export const investmentsTotalsOf = (
  data: InvestmentsResponse | undefined,
): InvestmentsTotals => {
  if (!data) {
    return ZERO;
  }
  const keys = Object.keys(ZERO) as Array<keyof InvestmentsTotals>;
  return keys.reduce(
    (totals, key) => ({ ...totals, [key]: data[key] }),
    {} as InvestmentsTotals,
  );
};

// Both figures are the API's, and the percentage is never re-derived here: PMA-358 defines total
// return as since-inception Modified Dietz, which `earnedValue / investedValue` is not.
export const headlineChangeOf = ({
  earnedValue,
  totalReturnPercent,
  totalReturnPercentStateReason,
}: InvestmentsTotals): InvestmentsHeadlineChange => ({
  changeValue: earnedValue,
  changePercent: totalReturnPercent,
  changePercentStateReason: totalReturnPercentStateReason,
});
